/**
 * @file
 * @author chenxin35
 */
import React, { useContext, useMemo } from 'react';
import { OutlinedAppstore } from 'acud-icon';
import classnames from 'classnames';
import Tooltip from '../tooltip';
import MenuContext from './MenuContext';
import { MenuContext as BaseMenuContext } from './rc-menu/context/MenuContext';
import { cloneElement } from '../_util/reactNode';
;
const ItemCustom = props => {
    const { children, icon, popup, popupClassName } = props;
    const { prefixCls } = useContext(MenuContext);
    const { inlineCollapsed } = useContext(BaseMenuContext);
    // 折叠时hover提示
    const renderPopup = useMemo(() => {
        if (inlineCollapsed && popup) {
            return popup;
        }
        return null;
    }, [inlineCollapsed, children]);
    const renderItemChildren = useMemo(() => {
        if (!inlineCollapsed) {
            return children;
        }
        // 折叠时展示icon
        const copyIcon = cloneElement((icon || <OutlinedAppstore />), {
            // 有hover提示时高亮icon
            className: classnames({ [`${prefixCls}-item-custom-popup-icon`]: popup })
        });
        return copyIcon;
    }, [inlineCollapsed, children, icon, prefixCls]);
    return (<Tooltip title={renderPopup} placement="right" overlayClassName={popupClassName}>
            <div className={`${prefixCls}-item-custom`}>
                {renderItemChildren}
            </div>
        </Tooltip>);
};
export default ItemCustom;
